module.exports = {
  'CHINESE': require('./chinese_simplified'),
  'CHINESE_SIMPLIFIED': require('./chinese_simplified'),
  'CHINESE_TRADITIONAL': require('./chinese_traditional'),
  'CZECH': require('./czech'),
  'ENGLISH': require('./english'),
  'FRENCH': require('./french'),
  'ITALIAN': require('./italian'),
  'JAPANESE': require('./japanese'),
  'KOREAN': require('./korean'),
  'PORTUGUESE': require('./portuguese'),
  'RUSSIAN': require('./russian'),
  'SPANISH': require('./spanish'),
  'TURKISH': require('./turkish')
};
